import styled from '@emotion/styled';
import { css } from '@emotion/react/macro';

import { breakpoints } from 'styles/basic';

import Button from 'components/ui/Button';

import { AutenticateButtonProps } from './AutenticateButton';

const Wrapper = styled.div<AutenticateButtonProps>`
  ${(props) => props.mobileShow && css`
    display: block;
    margin-bottom: 3rem;

    @media (min-width: ${breakpoints.portraitTablet}) {
      display: none;
    }
  `};

  ${(props) => !props.mobileShow && css`
    display: none;

    @media (min-width: ${breakpoints.portraitTablet}) {
      display: block;
    }
  `};
`;

const StyledLoginButton = styled(Button)`
  width: 16.5rem;
`;

export {
  Wrapper,
  StyledLoginButton
};
